
export default class Index extends HTMLDivElement {

    connectedCallback() {
        this.init();
    }

    init() {
        this.initNestedList();
        this.initAddEditValueButton();
        this.initDeleteValueButton();
    }

    initNestedList (container) {
        var self =this;
        // Initialise container if undefined
        container = typeof container !== 'undefined' ? container : $('.nestable-items');

        // Initialize Nestable for all availble list on page
        container.nestable({
            group: 0,
            maxDepth: 1
        }).on('change', self.saveNewOrder);

    }


    saveNewOrder (e) {

        var request = {
            new_order: $(this).nestable('serialize'),
            attribute_id: $(this).data('attribute-id')
        };

        $.ajax({
            url: '/admin/attributs/valeurs/deplacer',
            type: 'POST',
            data: request,
            success :function (data) {

                toastr.success(data.message);
            },
            error : function (data) {

                toastr.error('Une erreur est survenue au cours du changement de l\'ordre', 'Attention!');
                window.location.reload();
            }
        });

    }


    updateNestableList (container, values_list) {

        // Update .nestable-list-container DIV html
        container.find('.nestable-items').html(values_list);

        // Force reloading associated list
        //this.initNestedList(container.find('.nestable-items'));

    }


    initAddEditValueButton () {
        var self =this;
        $('#page-wrapper').on('click', 'a.jsAddValue, a.jsEditValue', function (e) {

            e.preventDefault();

            HegydCore.initRemoteModal('#modal', $(this).data('href'), self.initAddEditValuePopup, function (data) {
                toastr.success(data.message);
                // Replace values list content and reload nestable on list
                var $container = $('#attribute_' + data.attribute_id);

                self.updateNestableList($container, data.values_list);
            });

        });

    }


    initAddEditValuePopup () {

        // Load Select2 if available for some fields
        HegydCore.initSelect2();
        HegydCore.initColorPicker();
    }


    initDeleteValueButton () {
        var self = this;
        $('#page-wrapper').on('click', 'a.jsDeleteValue', function (e) {
            var $this = $(this);
            var $this = $(this);

            e.preventDefault();

            swal({
                title: 'Êtes-vous sûr ?',
                text: "Voulez-vous supprimer cette valeur ?",
                allowOutsideClick: true,
                type: 'warning',
                showCancelButton: true,
                closeOnConfirm: false,
                closeOnCancel: true,
                confirmButtonColor: '#D2282D',
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Oui !',
                showLoaderOnConfirm: true,
                preConfirm: function () {
                    return new Promise(function (resolve) {
                        $.ajax({
                            url: $this.data('href'),
                            method: 'DELETE',
                            success: function (data) {
                                toastr.success(data.message);
                                // Remove item in HTML list
                                self.removeValueItem(data.value_id);
                            },
                            error :function () {
                                toastr.error('Une erreur est survenue');
                            },
                            complete : function () {
                                resolve();
                            },
                            then : function (result) {
                                swal.close();
                            }
                        });
                    });
                }
            });
        });
    }


    removeValueItem (valueId) {

        if (valueId != undefined) {
            var $valueItem = $('#value_' + valueId);

            // If value item found then remove it, else reload all the page
            if ($valueItem != undefined) {
                $valueItem.hide('slow', function () {
                    $valueItem.remove();
                });
            } else {
                window.location.reload();
            }
        }

    }

}

customElements.define('eav-index', Index, {extends: 'div'});
